import * as React from "react";
import { IMaskMixin } from "react-imask";
import { FactoryStaticOpts } from "imask";
import { Input } from "@utdanningsdirektoratet/input";

type InputProps = React.ComponentProps<typeof Input>;
export interface MaskedInputProps extends Omit<InputProps, "onChange" | "onBlur" | "onFocus" | "ref"> {
  integerLimit?: number;
  allowDecimal?: boolean;
  thousandsSeparator?: string;
  placeholderChar?: string;
  blocks?: Record<string, FactoryStaticOpts>;
  max?: number;
  min?: number;
  onChange?: (value: string) => void;
  onBlur?: (value: string) => void;
  onFocus?: (value: string) => void;
  mask: FactoryStaticOpts["mask"];
}

const MaskedComponent = IMaskMixin<HTMLInputElement>(({ inputRef, ...props }) => {
  return <Input {...props} ref={inputRef} />;
});

const MaskedInput: React.FC<MaskedInputProps> = ({
  onChange,
  onBlur,
  onFocus,
  mask,
  blocks,
  thousandsSeparator,
  placeholderChar = "_",
  integerLimit,
  max = Number.MAX_SAFE_INTEGER,
  min = 0,
  allowDecimal,
  value,
  selectOnClick = true,
  ...rest
}) => {
  const deferredValue = React.useDeferredValue(value);
  return (
    <MaskedComponent
      {...rest}
      mask={mask}
      blocks={blocks}
      selectOnClick={selectOnClick}
      lazy={false}
      thousandsSeparator={thousandsSeparator}
      onAccept={(val: string): void => {
        if (onChange) onChange(val);
      }}
      onBlur={() => {
        if (onBlur) onBlur(`${value}`);
      }}
      onFocus={() => {
        if (onFocus) onFocus(`${value}`);
      }}
      placeholderChar={placeholderChar}
      max={integerLimit ? +"9".repeat(integerLimit) : max}
      min={min}
      scale={allowDecimal ? 10 : 0}
      defaultValue={deferredValue}
      value={value !== deferredValue ? value : undefined}
      unmask
    />
  );
};

export default MaskedInput;
